import {useGrpcRequestMutation} from '@aboutyou/data-fetcher';
import {ArticleDetailService_ReportLegalConcernFormLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.grpc.lazy';

export const useSubmitLegalReport = () => {
  const {mutateAsync} = useGrpcRequestMutation(
    ArticleDetailService_ReportLegalConcernFormLazy,
  );

  return mutateAsync;
};
